export default "__VITE_ASSET__B_9Ji7ko__"